import { AccountConfigService } from './../../../services/account-config/account-config.service';
import { AuthService } from './../../../../auth/services/auth/auth.service';
import { Component, forwardRef, Inject, OnInit, HostBinding, Output, EventEmitter } from '@angular/core';
import { MFormation, MGridSettings, MUser } from '@argalis-apps/models';
import { DocumentService } from '../../../services/document/document.service';
import { FormationService } from '../../../services/formation/formation.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import config from './formation-list.config';

@Component({
  selector: 'ags-formation-list',
  templateUrl: './formation-list.component.html',
  styleUrls: ['./formation-list.component.scss']
})
export class FormationListComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  private userConnected: MUser.CUser = null;
  public gridSettings: MGridSettings.IGridSettings = config;
  public kendogridlistColumnsname: any[] = [
    {
      field: 'reference',
      title: 'Référence'
    },
    {
      field: 'beginofsession',
      title: 'Début'
    },
    {
      field: 'endofsession',
      title: 'Fin'
    },
    {
      field: 'location',
      title: 'Ville'
    },
    {
      field: 'modalite',
      title: 'Modalité'
    },
    {
      field: 'libelle',
      title: 'Formation'
    },
    {
      field: 'statutsession',
      title: 'Status'
    }
  ];

  constructor(
    @Inject(forwardRef(() => AuthService)) private authService: AuthService,
    public documentService: DocumentService,
    private accountConfigService: AccountConfigService,
    private formationService: FormationService,
    private router: Router,
  ) {
    this.userConnected = this.authService.userConnected;
    this.authService.userChange.subscribe((user: MUser.CUser) => {
      this.userConnected = user;
    });
  }
  @Output() display = new EventEmitter<MFormation.IFormationInfo>();
  public listformation: Observable<MFormation.IFormationInfo[]>;

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
    if (this.userConnected) {
      this.listformation = this.formationService.getListFormationByClient(
        (this.userConnected.company.id || 0).toString()
      );
    } else {
      this.router.navigate(['/'], {});
    }
  }

  clickedColumn(id: number) {
    this.listformation.pipe(take(1)).subscribe((formations: MFormation.IFormationInfo[]) => {
      const formationInfo = formations.find(formation => formation.id === id);
      if (formationInfo) {
        this.display.emit(formationInfo);
        this.router.navigate([`/`, this.accountConfigService.routingBaseUri, 'mesformations', formationInfo.id]);
      }
    });
  }
}
